import React from "react";
import { growth, platform, trust } from "../../assets";

/**
 * @author
 * @function PlatformSection
 **/

export const PlatformSection = (props) => {
  return (
    <section className="lg:px-2 md:px-4 sm:px-4">
      <div className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-8 md:py-8 sm:py-8">
        <div>
          <div className="flex justify-center items-center">
            <h2 className="lg:text-3xl md:text-2xl sm:text-xl mb-8 lg:px-0 md:px-0 sm:px-4">
              Why WristLink
            </h2>
            {/* <h2 className="text-[28px] font-semibold">Why WristLink</h2> */}
          </div>
          <div className="lg:grid lg:grid-cols-3 sm:flex sm:flex-col gap-4">
            <div className="flex flex-col bg-primary px-4 py-4 rounded items-center">
              <div className=" bg-white rounded h-[200px] w-full flex justify-center items-center">
                <img src={platform} className="h-[80px]" />
              </div>
              <h2 className="text-[20px] font-bold my-4">
                Commission-Free Platform
              </h2>
              <p className="text-center">
                Enjoy the freedom of trading with no hidden fees or commission
                costs. With WristLink’s subscription model, you can maximize
                profits while keeping your costs predictable.
              </p>
            </div>

            <div className="flex flex-col bg-primary px-4 py-4 rounded items-center">
              <div className=" bg-white rounded h-[200px] w-full flex justify-center items-center">
                <img src={trust} className="h-[80px]" />
              </div>
              <h2 className="text-[20px] font-bold my-4">
                Exclusivity & Trust
              </h2>
              <p className="text-center">
                Join a carefully curated network of vetted watch professionals.
                Every member is verified, creating a trusted and secure space to
                do business with confidence.
              </p>
            </div>

            <div className="flex flex-col bg-primary px-4 py-4 rounded items-center">
              <div className=" bg-white rounded h-[200px] w-full flex justify-center items-center">
                <img src={growth} className="h-[70px]" />
              </div>
              <h2 className="text-[20px] font-bold my-4">
                Enhanced Business Growth
              </h2>
              <p className="text-center">
                WristLink is built for dealers who want to expand their
                business. Connect directly with global dealers, browse exclusive
                inventory, and build valuable partnerships without
                intermediaries.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
